import { createBrowserRouter } from "react-router-dom";
import Home from "../Pages/Home";
import About from "../Pages/About";
import Gallery from "../Pages/Gallery";
import Vlog from "../Pages/Vlog";
import Membership from "../Membership/membership";
import AdminLayout from "../Layout/AdminLayout";
import Dashboard from "../Admin/Dashboard";
import Donation from "../Admin/DonationTable";
import AllMember from "../Admin/allMember";
import Notice from "../Admin/Notice";
import DonationRecord from "../Admin/DonationRecord";
import CommitteeForm from "../Admin/ComitteeMember";
import EventForm from "../Admin/EventImg";
import VideoForm from "../Admin/VideoVlog";
import LoginPage from "../Pages/Login/Login";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home></Home>,
  },
  {
    path: "/about",
    element: <About></About>,
  },
  {
    path: "/gallery",
    element: <Gallery></Gallery>,
  },
  {
    path: "/vlog",
    element: <Vlog></Vlog>,
  },
  {
    path: "/membership",
    element: <Membership></Membership>,
  },
  {
    path: "/login",
    element: <LoginPage></LoginPage>,
  },
  {
    path: "/admin",
    element: <AdminLayout></AdminLayout>,
    children: [
      {
        path: "/admin/dashboard",
        element: <Dashboard></Dashboard>,
      },
      {
        path: "/admin/donation",
        element: <Donation></Donation>,
      },
      {
        path: "/admin/member",
        element: <AllMember></AllMember>,
      },
      {
        path: "/admin/notice",
        element: <Notice></Notice>,
      },
      {
        path: "/admin/donationRecord",
        element: <DonationRecord></DonationRecord>,
      },
      {
        path: "/admin/comittee",
        element: <CommitteeForm></CommitteeForm>,
      },
      {
        path: "/admin/event",
        element: <EventForm></EventForm>,
      },
      {
        path: "/admin/vlog",
        element: <VideoForm></VideoForm>,
      },
    ],
  },
]);

export default router;
